import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { useApolloClient } from "@apollo/client/react";
import { useRtTrackMutation, useRtRecommendQuery } from "@/hooks";
import { RTOASTER_RECOMMEND_QUERY } from "@/apollo/queries/rtoaster";

/**
 * useRtoasterTrack.
 *
 * rtoasterのtrackを送信する
 *
 * @param {string} referer
 */
export function useRtoasterTrack(referer) {
  const router = useRouter();
  const [rtoasterTrack] = useRtTrackMutation();
  const referrer = useRef(referer);

  useEffect(() => {
    const handler = () => {
      const queryString = [
        ...new URLSearchParams(window.location.search).entries(),
      ].reduce((obj, e) => {
        return { ...obj, [e[0]]: e[1] };
      }, {});

      rtoasterTrack({
        variables: {
          location: `${window.location.origin}${window.location.pathname}`,
          referrer: referrer.current,
          sid: queryString?.rtsid,
        },
      });
      referrer.current = window.location.href;
    };

    router.events.on("routeChangeComplete", handler);
    handler();

    return () => {
      router.events.off("routeChangeComplete", handler);
    };
  }, []);
}

/**
 * useRtoasterRecommendWithCache.
 *
 * Rtoasterのレコメンドを取得して、elemendIdが1件ずつ指定された場合のROOT_QUERYのキャッシュを作る
 *
 * @param {string[]} elementIds
 */
export function useRtoasterRecommendWithCache(elementIds) {
  const client = useApolloClient();
  const [dataCached, setDataCached] = useState(false);

  const result = useRtRecommendQuery({
    variables: {
      location: `${window.location.origin}${window.location.pathname}`,
      elementIds,
    },
    onCompleted: (data) => {
      if (data?.recommend) {
        for (const elementId of elementIds) {
          const cacheData = data.recommend.find(
            (d) => d.elementId === elementId
          );
          if (cacheData) {
            client.writeQuery({
              query: RTOASTER_RECOMMEND_QUERY,
              data: { recommend: [cacheData] },
              variables: {
                location: `${window.location.origin}${window.location.pathname}`,
                elementIds: [elementId],
              },
            });
          }
        }
      }
      setDataCached(true);
    },
  });

  return { ...result, loading: !dataCached };
}
